import React from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceCreateEmailComponent from "../../../../components/Admin/emails/services/ServiceCreateEmailComponent";

const ServiceListEmailPage = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/email/danh-sach-email-dich-vu.html');
    }

    return <ServiceCreateEmailComponent redirectFinish={ () => redirect() } />;
}

export default ServiceListEmailPage;